import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Recycle = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.224 15.543l-.813-1.464-1.748.972.812 1.461c.048.085.082.173.104.264a1.024 1.024 0 01-.014.5.988.988 0 01-.104.235 1 1 0 01-.347.352.978.978 0 01-.513.137H14v-2l-4 3 4 3v-2h4.601c.278 0 .552-.037.811-.109a2.948 2.948 0 001.319-.776c.178-.179.332-.38.456-.593a2.992 2.992 0 00.336-2.215 3.163 3.163 0 00-.299-.764zM5.862 11.039l-2.31 4.62a3.06 3.06 0 00-.261.755 2.997 2.997 0 00.851 2.735c.178.174.376.326.595.453A3.022 3.022 0 006.236 20H8v-2H6.236a1.016 1.016 0 01-.5-.13.974.974 0 01-.353-.349 1 1 0 01-.149-.468.933.933 0 01.018-.245c.018-.087.048-.173.089-.256l2.256-4.512 1.599.923L8.598 8 4 9.964l1.862 1.075zm12.736 1.925L19.196 8l-1.638.945-2.843-5.117a2.95 2.95 0 00-1.913-1.459 3.227 3.227 0 00-.772-.083 3.003 3.003 0 00-1.498.433A2.967 2.967 0 009.41 3.944l-.732 1.464 1.789.895.732-1.465c.045-.09.101-.171.166-.242a.933.933 0 01.443-.27 1.053 1.053 0 01.53-.011.963.963 0 01.63.485l2.858 5.146L14 11l4.598 1.964z",
    key: "k0"
  }));
});
Recycle.displayName = 'Recycle';
export var RecycleDimensions = {
  height: 24,
  width: 24
};